<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-google-classroom" title="Available Videos">
        <v-card-actions v-if="isWrite">
          <router-link :to="{ name: 'uploadVideos' }">
            <v-btn color="accent" elevation="1" absolute right top> <v-icon left>mdi-plus</v-icon>Upload more</v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="6">
              <label class="body-2 font-weight-medium">Class</label>
              <v-autocomplete
                class="my-0 py-1"
                single-line
                placeholder="--All Classes--"
                name="classSelect"
                v-model="selectedClassID"
                required
                v-on:change="changeSections()"
                item-value="id"
                :items="classes"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
              <!-- :v-bind="class1.id" -->
            </v-col>
            <v-col cols="12" md="6">
              <label class="body-2 font-weight-medium">
                Section
              </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Sections--"
                name="sectionSelect"
                v-model="selectedSectionID"
                required
                v-on:change="getVideoList()"
                item-value="id"
                :items="classWiseSections"
                key="id"
                item-text="name"
              >
              </v-autocomplete>
              <!-- :v-bind="section.id" -->
            </v-col>
          </v-row>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ totalCount }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
            <!-- <v-btn v-if="isWrite" elevation="1" @click="save" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
            <v-icon left>mdi-content-save</v-icon>
            save
          </v-btn> -->
          </v-card-text>
          <v-divider class="my-0 py-0"></v-divider>
          <v-data-table
            :headers="headers"
            :items="videos"
            :search="search"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
          >
            <template v-slot:item.url="{ item }">
              <v-btn min-width="0" small class="px-2 ml-1 ma-1" @click.prevent="viewURLCopier(item.id)" v-if="item.urlPath">
                <v-icon small color="black">mdi-eye</v-icon>
              </v-btn>
              <div class="d-flex justify-center" v-else>
                --
              </div>
            </template>

            <template v-slot:item.actions="{ item }" v-if="isWrite">
              <v-btn min-width="0" class="px-2 ml-1 ma-1" small color="error" @click.prevent="deleteVideo(item.id)" v-if="item.urlPath">
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
              <div class="d-flex justify-center" v-else>
                --
              </div>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No video's found!&hellip;</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <v-dialog v-model="toggleURLCopier" width="800">
        <v-card rounded="lg">
          <form>
            <v-card-title class="headline grey lighten-2 pr-16 mb-12">{{ selectedVideo.name }}</v-card-title>
            <v-btn class="mt-8" color="error" elevation="1" x-small fab absolute top right type="button" >
              <v-icon @click="toggleURLCopier = false" small>mdi-close</v-icon>
            </v-btn>
            <form @submit.prevent="copyURL()" class="px-4">
              <v-text-field label="URL" outlined dense autofocus v-model="selectedVideo.urlPath" ref="copyURL" id="copyUrl"></v-text-field>
              <v-divider></v-divider>
              <v-card-actions class="pb-6">
                <v-spacer></v-spacer>
                <v-btn elevation="1" color="success" type="submit" @click.prevent="copyURL()">Copy URL</v-btn>
              </v-card-actions>
            </form>
          </form>
        </v-card>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 's3videoList',
  components: {
    VCardComponent,
    MaterialCard
  },
  data () {
    return {
      enableFilterModal: false,
      videos: [],
      search: '',
      classID: '',
      classes: [],
      franchiseeID: '',
      toggleURLCopier: false,
      selectedClassID: '',
      selectedSectionID: '',
      franchiseeArr: [],
      isLoading: false,
      paginated: false,
      sections: [],
      classWiseSections: [],
      totalCount: 0,
      perPage: 10,
      selectedVideo: {},
      isWrite: false,
      headers: [
        { text: 'Video Name', sortable: false, value: 'name' },
        { text: 'Franchisee Name', sortable: false, value: 'franchisee.companyName' },
        { text: 'Class Name', sortable: false, value: 'studentClass.name' },
        { text: 'Section Name', sortable: false, value: 'studentSection.name' },
        { text: 'Video URL', sortable: false, value: 'url' },
        { text: 'Upload Status', sortable: false, value: 'uploadStatus' },
        { text: 'Delete', sortable: false, value: 'actions' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      this.isWrite = await Utils.helper.getIsWriteFun(this.$route)
      await this.onFranchiseeChange()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          if (!this.franchiseeID) {
            Utils.helper.openDrawer(this)
          }
          if (this.franchiseeID) {
            await this.getClassList()
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    changeSections: async function () {
      try {
        this.selectedSectionID = ''
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
        this.isLoading = false
        await this.getVideoList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        if (!this.franchiseeID) {
          return this.$dialog.error({
            text: 'Please Select Franchisee',
            title: 'Error'
          })
        }
        const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&isAllValue=true`)
        if (data) {
          this.classes = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
        this.isLoading = false
        await this.getVideoList()
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getVideoList: async function () {
      try {
        let reqData = {}
        this.isLoading = true
        if (this.franchiseeID) {
          reqData.franchiseeID = this.franchiseeID
        }
        if (this.selectedClassID) {
          reqData.classID = this.selectedClassID
        }
        if (this.selectedSectionID) {
          reqData.sectionID = this.selectedSectionID
        }
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/get-all-videos`, {
          params: reqData
        })
        if (data) {
          this.totalCount = data.count
          data.rows.forEach(row => {
            if (row.urlPath) {
              console.log(row.id)
              row.urlPath = encodeURIComponent(`${row.urlPath}`)
              row.urlPath = `${window.location.origin}/videoplayer/${row.name}/${row.urlPath}`
            }
            if (_.isEqual(row.uploadStatus, 'Failed')) {
              row.urlPath = null
            }
          })
          this.videos = data.rows
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteVideo: async function (id) {
      let that = this
      this.$dialog.warning({
        text: 'Do you want to delete video?',
        title: 'Deleting Event',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'error',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                /* activate franchisee @ b2b system */
                await http.get(`${constants.API_URL}/api/franchisee/delete-video/${id}`)
                this.isLoading = false
                that.getVideoList()
                return this.$dialog.error({
                  text: 'Video deleted successfully!',
                  title: 'Error'
                })
              } catch (e) {
                this.isLoading = false

                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.enableUniformModal = false
                console.log('error in deleting video : ', errorMessage)
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    },
    viewURLCopier: async function (id) {
      try {
        this.isLoading = true
        this.selectedVideo = this.videos.find(obj => obj.id === id)
        this.toggleURLCopier = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        console.log('error in view url : ', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    copyURL: async function () {
      try {
        this.isLoading = true
        const element = document.getElementById('copyUrl')
        element.select()
        /* Copy the text inside the text field */
        document.execCommand('copy')
        this.toggleURLCopier = false
        return this.$dialog.message.info('URL copied successfully!', {
          position: 'top',
          timeout: 5000
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        console.log('error in copeing url : ', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
